import React from 'react';
import { Select } from 'antd';
import useContainerRef from '@src/hooks/utils/useContainerRef';
import { StyledResizeLabel, StyledResizeWrapper } from './styled';

export const BASE_HEIGHT = 3;
export const TABLE_HEIGHT_MAPPING = {
  s: BASE_HEIGHT + 7,   // row span of 10, each row is 47px => dropdown + header + total + 7 data rows
  m:  BASE_HEIGHT + 12, // ~ 12 data rows
  l:  BASE_HEIGHT + 17  // ~ 17 data rows
}

const options = [
  { label: 'Small', value: 's' },
  { label: 'Medium', value: 'm' },
  { label: 'Large', value: 'l' },
]

function Resize({ value, onChange }) {

  const { containerRef, getContainer } = useContainerRef();

  return (
    <StyledResizeWrapper ref={containerRef}>
    <StyledResizeLabel>Size</StyledResizeLabel>
      <Select
        value={value}
        bordered={false}
        onChange={onChange}
        options={options}
        dropdownStyle={{ minWidth: 100 }}
        getPopupContainer={getContainer}
      />
    </StyledResizeWrapper>
  )
}

export default Resize;
